import React, { Component } from "react";
import "./DictionaryTools.css";
import PropTypes from "prop-types";
import SearchInputWithSuggestions from "./../search/SearchInputWithSuggestions/SearchInputWithSuggestions";
import DictionaryToolsResultPanel from "./components/DictionaryToolsResultPanel/DictionaryToolsResultPanel";
import Action from "./../formElements/Action/Action";
import closeImg from "./images/close.svg";
import {
  dictionarySearch,
  getPreviousSearch,
  addItemToPreviousSearch,
  addWordToDictionary,
} from "../../services/dictionary";
import { Translation } from "react-i18next";

export class DictionaryMode {
  static DEFINE = "define";
  static TRANSLATE = "translate";
  static SAVE = "save";

  static getAllModes = () => {
    return [DictionaryMode.DEFINE, DictionaryMode.TRANSLATE, DictionaryMode.SAVE];
  };
}

const DEFAULT_ERROR_TEXT = "Tool.noResult";

export default class DictionaryTools extends Component {
  constructor(props) {
    super(props);

    this.state = {
      text: this.props.searchValue,
      mode: this.props.mode || DictionaryMode.DEFINE,
      searchSuggestions: getPreviousSearch(),
      showSpinner: false,
      defineContent: {
        text: "",
        content: null,
      },
      openAddDialog: false,
      myWordsSearchText: "",
    };

    this.onSearch = this.onSearch.bind(this);
    this.onTranslate = this.onTranslate.bind(this);
    this.onSaveWord = this.onSaveWord.bind(this);
    this.onTextChanged = this.onTextChanged.bind(this);
    this.onModeChanged = this.onModeChanged.bind(this);
    this.onRefresh = this.onRefresh.bind(this);
  }

  onTextChanged(text) {
    this.setState({ text: text });
  }

  onModeChanged(mode) {
    if (
      mode === DictionaryMode.DEFINE &&
      this.state.text &&
      this.state.text !== this.state.defineContent.text
    ) {
      if (this.state.mode !== mode) {
        this.setState({ mode: mode });
      }
      this.onSearch(this.state.text, mode);
    } else {
      this.setState({ mode: mode });
    }
  }

  onTranslate(text) {
    this.setState({
      text: text,
      mode: DictionaryMode.TRANSLATE,
    });
  }
  onSaveWord(text) {
    this.setState({
      text: text,
      mode: DictionaryMode.SAVE,
    });
    addWordToDictionary(
      {
        word: text,
      },
      () => {
        this.resultPanel.refresh(null, 1);
      },
      e => {
        window.console.log(e);
      }
    );
  }
  onSearch(text, mode = "") {
    if (this.state.showSpinner) {
      return;
    }

    if (this.state.mode === DictionaryMode.SAVE && !mode) {
      // search my vocabrary list when user enters after change the word in "My Vocab" tab
      this.setState({
        myWordsSearchText: this.state.text,
      });
    } else {
      // This does search in dictionary.
      const newState = { showSpinner: true };
      if (!text) {
        if (!this.state.text) {
          return;
        }
        text = this.state.text;
      } else {
        newState.text = text;
      }

      if (this.state.mode !== DictionaryMode.DEFINE) {
        newState.mode = DictionaryMode.DEFINE;
      }
      newState.searchSuggestions = addItemToPreviousSearch(text);
      this.setState(newState);
      dictionarySearch(
        text,
        resp => {
          this.setState({
            defineContent: {
              text: text,
              content: resp,
            },
            showSpinner: false,
          });
        },
        () => {
          this.setState({
            defineContent: {
              text: text,
              content: DEFAULT_ERROR_TEXT,
            },
            showSpinner: false,
          });
        }
      );
    }
  }

  onRefresh() {
    this.resultPanel && this.resultPanel.refresh(null, 1);
  }

  onClose() {
    this.setState({ myWordsSearchText: "" });
  }

  render() {
    return (
      <Translation>
        {t => (
          <div className="dictionary-tools-panel">
            <div className="dictionary-header">
              <span>{t("Tool.LANGUAGE TOOLS")}</span>
              <Action className="close-action" onClick={this.props.onClose}>
                <img src={closeImg} alt="close" />
              </Action>
            </div>

            <div className="dictionary-content">
              <SearchInputWithSuggestions
                value={this.state.text}
                suggestions={this.state.searchSuggestions}
                onValueChanged={this.onTextChanged}
                onSearch={this.onSearch}
              />
              <DictionaryToolsResultPanel
                isSelectionOpened={this.props.isSelectionOpened}
                mode={this.state.mode}
                showSpinner={this.state.showSpinner}
                searchText={this.state.text}
                myWordsSearchText={this.state.myWordsSearchText}
                defineContent={
                  this.state.defineContent.content === DEFAULT_ERROR_TEXT
                    ? t(this.state.defineContent.content) + "."
                    : this.state.defineContent?.content
                }
                onModeChanged={this.onModeChanged}
                onTextChanged={this.onTextChanged}
                onOpenAddWordDialog={this.props.onOpenAddWordDialog}
                onOpenExampleDialog={this.props.onOpenExampleDialog}
                onOpenPracticeVocabDialog={this.props.onOpenPracticeVocabDialog}
                openSidebar={this.props.openPrefilledSidebar}
                updateParentState={this.props.updateParentState}
                ref={drp => (this.resultPanel = drp)}
              />
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

DictionaryTools.propTypes = {
  searchValue: PropTypes.string,
  mode: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};
